import axios from "axios";
export default {
  report: (id, cancelToken) => axios.get(`/api/budget/${id}/report`, { cancelToken, responseType: "blob" })
};
